import React from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Page from '../Components/Page';
import {Breadcrumbs} from '../Components/Breadcrumbs';
import SelectDropdown from "../Components/Dropdowns/SelectDropdown";
import {ProjectionMaintenanceUniverseTab} from './ProjectionMaintenanceUniverseTab';
import {ProjectionMaintenanceStoreTab} from './ProjectionMaintenanceStoreTab';
import {ProjectionMaintenanceProjectionTab} from './ProjectionMaintenanceProjectionTab';
import {ProjectionMaintenanceCellTargetsTab} from './ProjectionMaintenanceCellTargetsTab';
import {ProjectionMaintenanceCellToMarketsTab} from './ProjectionMaintenanceCellToMarketsTab';
import {ProjectionLoadTimer} from './Components/ProjectionLoadTimer';

const servicesDropdown =
    <div className={'title-object'}>
        <SelectDropdown
            options={[
                {label: 'Inflation Factors', value: 'Inflation Factors', url: '/inflationFactorService'},
            ]}
            id={'exclusion_dropdown'}
            selectValue={'Services...'}
            onChange={o => window.open(o.url, '_blank')}
        />
    </div>

function ProjectionMaintenance() {
    return (
        <Page breadCrumbs={<Breadcrumbs items={[{label: 'Services'}, {label: 'Projections'}, {label: 'Projection Maintenance'}]}/>} name={'Projection Maintenance'} headerSubComponent={servicesDropdown}>
            <ProjectionLoadTimer>
                <Tabs>
                    <TabList>
                        <Tab data-testid={'projection-maintenance-projection-tab-name'}>Projection</Tab>
                        <Tab data-testid={'projection-maintenance-universe-tab-name'}>Universe</Tab>
                        <Tab data-testid={'projection-maintenance-stores-tab-name'}>Stores</Tab>
                        <Tab data-testid={'projection-maintenance-cell-targets-tab-name'}>Cell Targets</Tab>
                        <Tab data-testid={'projection-maintenance-cell-to-markets-tab-name'}>Cell to Markets</Tab>
                    </TabList>
                    <TabPanel data-testid={'projection-maintenance-projection-tab-panel'}>
                        <ProjectionMaintenanceProjectionTab/>
                    </TabPanel>
                    <TabPanel data-testid={'projection-maintenance-universe-tab-panel'}>
                        <ProjectionMaintenanceUniverseTab/>
                    </TabPanel>
                    <TabPanel data-testid={'projection-maintenance-stores-tab-panel'}>
                        <ProjectionMaintenanceStoreTab/>
                    </TabPanel>
                    <TabPanel data-testid={'projection-maintenance-cell-targets-tab-panel'}>
                        <ProjectionMaintenanceCellTargetsTab/>
                    </TabPanel>
                    <TabPanel data-testid={'projection-maintenance-cell-to-markets-tab-panel'}>
                        <ProjectionMaintenanceCellToMarketsTab/>
                    </TabPanel>
                </Tabs>
            </ProjectionLoadTimer>
        </Page>
    );
}

export default ProjectionMaintenance;
